import css from './InnerBlockGradient.module.scss';
import classNames from 'classnames';

export default function InnerBlockGradient({isValue}) {
  return (
    <div className={classNames(css.innerBlockGradient, {[css.value]: isValue})}/>
  );
}